import React, { useEffect, useState } from "react";

import {
  Typography,
  Grid,
  Button,
  Link,
  Dialog,
  DialogActions,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import sweptBlueLogo from "../../assets/images/sweptBlueLogo.png";
import {
  apiRequest,
  customNavigate,
  formatApiRequestError,
} from "../../helpers";
import DialogContent from "../modals/DialogContent";
import DialogTitle from "../modals/DialogTitle";

const useStyles = makeStyles()((theme: any) => ({
  backdrop: {
    backgroundColor: theme.palette.background.default,
    textAlign: "center",
    padding: theme.spacing(1),
  },
  container: {
    maxWidth: "450px",
    margin: `${theme.spacing(2)} auto`,
    justifyContent: "center",
  },
  logo: {
    marginTop: theme.spacing(8),
    width: "170px",
  },
  modalContainer: {
    margin: "auto",
    maxWidth: "703px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

const ApproveProfileUpdate = () => {
  const { classes } = useStyles();
  const [params] = useSearchParams();

  const id = Number(params.get("var1")) || 0;
  const token = params.get("var2");

  const [showTokenExpiredModal, setShowTokenExpiredModal] = useState(false);
  const [showProfileUpdateSuccess, setShowProfileUpdateSuccess] =
    useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    apiRequest({
      method: "GET",
      endpoint: "v2/update-profile",
      params: { id: id, token: token },
      signal: abortController.signal,
    })
      .then(() => {
        setShowProfileUpdateSuccess(true);
      })
      .catch((error) => {
        setShowTokenExpiredModal(true);
        console.warn(
          "User ID or token is invalid or expired:",
          formatApiRequestError(error)
        );
      })
      .finally(() => {
        setTimeout(function () {
          customNavigate("/");
        }, 5000);
      });

    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={classes.backdrop}>
        <img src={sweptBlueLogo} alt="Swept" className={classes.logo} />
        <Grid className={classes.container} container>
          {showProfileUpdateSuccess && (
            <>
              <Grid item xs={12}>
                <Typography variant="h6">
                  Congratulations! <br />
                  Your profile update is complete, you will be redirected to the
                  sign-in page shortly. Click <Link href="/">here</Link> if you
                  encounter any issues.
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </div>
      <Dialog
        className={classes.modalContainer}
        fullWidth
        onClose={() => customNavigate("/")}
        open={showTokenExpiredModal}
        PaperProps={{ square: true }}
      >
        <DialogTitle>Whoops, that's an expired link</DialogTitle>
        <DialogContent>
          <Typography>
            For security reasons, profile update links expire after 2 days.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => customNavigate("/")}
          >
            OKAY
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApproveProfileUpdate;
